import { Tax } from "..";
import {GetType, PostType} from "../Api";
import * as CallType from "../CallType";

export * as Group from "./Group";
export * as Component from "./Component";
export * as Template from "./Template";
export * as Order from "./Order";
export * as Product from "./Product";
export * as User from "./User";
export * as Tax from "./Tax";

export interface TotalsType {
	name?: string;
	country?: Tax.CountryType;
	row: [number, number][];
}

export interface UploadImage extends PostType<"no file to upload" | "invalid filename" | "unsupported filetype" | "file too big"> {
	Res: {
		image_id: string;
		image_name: string;
	}
}

export interface Totals extends GetType<"min higher than max"> {
	Query: {
		min: string;
		max: string;
	};
	Res: {
		totals: TotalsType[];
	};
}

export const Call = {
	totals: CallType.Get<Totals>("/staff/totals"),
};

